import { render } from "./edit.vue?vue&type=template&id=52cd0b78&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=52cd0b78&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-52cd0b78"

export default script